<template>
    <div>
        <loading-overlay :loading="loading"></loading-overlay>

        <!-- Name -->
        <v-text-field
            label="Recipient Name"
            placeholder="John Smith"
            name="name"
            v-model="copyOfRecipientInfo.name"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            v-validate="'required|name|two-words'"
            :error-messages="errors.first('name')"
            outlined
            color="primary"
        />

        <!-- Email -->
        <v-text-field
            label="Recipient Email"
            placeholder="Email@Example.com"
            name="email"
            v-model="copyOfRecipientInfo.paypal_id"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            v-validate="'required|email'"
            :error-messages="errors.first('email')"
            outlined
            color="primary"
        />

        <!-- Phone -->
        <v-text-field
            label="Recipient Phone #"
            placeholder="(555) 555-5555"
            name="phone"
            v-model="copyOfRecipientInfo.phone"
            @change="$emit('recipient-updated', copyOfRecipientInfo)"
            v-validate="'required|international-phone'"
            :error-messages="errors.first('phone')"
            outlined
            color="primary"
        />

        <!-- Save Recipient Details -->
        <v-switch
            v-if="continueButtonText !== 'SAVE'"
            label="Save Recipient Details?"
            v-model="canSaveRecipient"
            color="primary"
        />

        <v-card-actions class="pb-6">
            <v-spacer />
                <v-btn
                    x-large
                    color="primary"
                    dark
                    class="px-12"
                    @click="validateThenEmit"
                >
                {{ continueButtonText }}
                </v-btn>
            <v-spacer />
        </v-card-actions>
    </div>
</template>

<script>
    export default {
        props: {
            continueButtonText: {
                type: String,
                default: 'CONTINUE'
            },
            recipientInfo: Object
        },
        data: data,
        mounted: mounted,
        beforeDestroy: beforeDestroy,
        methods: getMethods(),
        watch: getWatched()
    }

    function getWatched(){
        return {
            recipientInfo: {
                handler: recipientInfo,
                immediate: true
            }
        }

        function recipientInfo(){
            const vm = this;
            if(vm.recipientInfo){
                Vue.set(vm, 'copyOfRecipientInfo', vm.recipientInfo);
            }
            if(Object.keys(this.recipientInfo).length){
                Vue.nextTick(() => {
                    vm.$validator.validateAll();
                });
            }
        }
    }

    function beforeDestroy(){
        const vm = this;
    }

    function data(){
        return {
            canSaveRecipient: false,
            copyOfRecipientInfo: {},
            confirm_paypal_id: '',
            loading: false,
        }
    }

    function mounted(){
        const vm = this;
        vm.positionBottomButton(15);
        if (vm.recipientInfo) {
            Vue.set(vm, 'copyOfRecipientInfo', vm.recipientInfo);
        }
    }

    function getMethods(){
        return {
            validateThenEmit: validateThenEmit,
        };

        function validateThenEmit(){
            const vm = this;

            vm.$validator.validateAll().then(submitIfValid);
            function submitIfValid(formIsValid){
                if(formIsValid){
                    vm.$emit('continue', vm.copyOfRecipientInfo)
                    if(vm.canSaveRecipient){
                        vm.$emit('saveRecipient', vm.copyOfRecipientInfo);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
